import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import { CollectionAdapter } from './collection.adapter';

export const collectionSelect = (state: RootState) => state.features.collections.collection;

export const collectionSelectors = CollectionAdapter.getSelectors();

export const selectCollection = createSelector(
    collectionSelect,
    (state) => collectionSelectors.selectAll(state)[0]
);

export const selectCollectionEntities = createSelector(
    collectionSelect,
    (state) => collectionSelectors.selectEntities(state)
);

export const selectCollections = createSelector(collectionSelect, (state) =>
    collectionSelectors.selectAll(state)
);
